import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: 'marketing-plan',
    name: 'MarketingPlans',
    redirect: (to) => ({ name: 'MarketingPlanConfigs', query: to.query, hash: to.hash }),
  },
  {
    path: 'marketing-plan/configs',
    name: 'MarketingPlanConfigs',
    component: () => import('@/pages/marketing-plan/index.vue'),
    meta: { title: '方案配置', parent: '营销管理' },
  },
  {
    path: 'marketing-plan/logs',
    name: 'MarketingPlanLogs',
    component: () => import('@/pages/marketing-plan/index.vue'),
    meta: { title: '触发记录', parent: '营销管理' },
  },
]

export default routes
